module.exports = __webpack_public_path__ + "static/media/davy.bea84362.png";